<template>
  <div class="container">
    <div class="panel text-center">
      <h1>Page Not Found</h1>
      <p>
        This page doesn't seem to exist
      </p>
      <div class="spacing">
        <themed-button :to="homeRoute">{{ homeLabel }}</themed-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'not-found',

  computed: {
    ...mapGetters(['activeCompany', 'inAdminArea', 'inLawyerArea']),

    homeRoute() {
      if (this.inAdminArea) {
        return { name: 'admin-dashboard' };
      }
      if (this.inLawyerArea) {
        return { name: 'lawyer-dashboard' };
      }
      return { name: this.activeCompany.id ? 'workflows' : 'index' };
    },

    homeLabel() {
      if (this.inAdminArea) {
        return 'Go to Admin Area';
      }
      if (this.inLawyerArea) {
        return 'Go to Lawyer Area';
      }
      return 'Go to Workflows';
    },
  },
};
</script>
